var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.752 16.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.672.7a34.274,34.274,0,0,0-6.3-.7,34.274,34.274,0,0,0-6.3.7A1.341,1.341,0,0,0,0,2.012V6.035c0,6.972,6.733,9.887,6.733,9.887a1.294,1.294,0,0,0,1.286,0s6.733-2.915,6.733-9.887V2.012A1.34,1.34,0,0,0,13.672.7Zm-6.3,14.047-.056-.031-.05-.025C7.056,14.6,2.635,12.6,1.573,8.047h5.8V1.341a33,33,0,0,1,6.011.667l.023,4.027a8.778,8.778,0,0,1-.232,2.012h-5.8v6.7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.372 0 7.374 0 7.376 0 7.372 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAdmin);
export default __webpack_public_path__ + "static/media/SystemAdmin.f489dcab8b72ce6dd3564157e4c1100b.svg";
export { ForwardRef as ReactComponent };